"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Container = _interopRequireDefault(require("./Container"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _styleHelper = require("../styleHelper2");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const StyledLink = _styledComponents.default.a.withConfig({
  displayName: "MenuItem__StyledLink",
  componentId: "sc-19l15yc-0"
})(["display:flex;align-items:center;flex:1;cursor:pointer;width:100%;height:50px;padding:0;transition:all 0.3s ease;font-size:16px;text-decoration:none;line-height:1.2;cursor:", ";color:", ";&:hover{color:", ";}", ";"], props => props.disabled ? 'default' : 'pointer', props => props.disabled ? props.text.theme.disabled : props.theme.text.normal, props => props.disabled ? props.text.theme.disabled : props.theme.text.text700, _styleHelper.margin);
const MenuItem = ({
  disabled,
  className,
  children,
  text,
  icon,
  onClick: handleOnClick,
  ...props
}) => {
  const onClick = event => {
    if (disabled) {
      event.preventDefault();
      return false;
    }
    if (handleOnClick) {
      return handleOnClick(event);
    }
    return true;
  };
  const iconRender = typeof icon === 'string' ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: icon,
    iconSize: "medium",
    marginRight: "10px",
    flex: "0 0 15px"
  }) : icon;
  return /*#__PURE__*/_react.default.createElement(StyledLink, _extends({}, props, {
    disabled: disabled,
    onClick: onClick,
    className: [className, disabled ? 'disabled' : false].filter(Boolean).join(' ')
  }), children || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, iconRender || /*#__PURE__*/_react.default.createElement(_Container.default, {
    width: "15px",
    flex: "0 0 15px"
  }), text));
};
MenuItem.propTypes = {
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  children: _propTypes.default.node,
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  onClick: _propTypes.default.func
};
MenuItem.defaultProps = {
  className: null,
  disabled: false,
  children: null,
  text: null,
  icon: null,
  onClick: null
};
const _default = MenuItem;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(StyledLink, "StyledLink", "/Users/jake.clayton/frontend/ls-common-client/src/components/MenuItem.js");
  reactHotLoader.register(MenuItem, "MenuItem", "/Users/jake.clayton/frontend/ls-common-client/src/components/MenuItem.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/MenuItem.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();